import { HTMLAttributes } from 'react';
import { BillRowVm } from '@/features/dashboard/bookingChanges/types/BillViewModel.ts';

/** Wspólna część propsów widoku wpuszczonego w rozwinięty kafel osoby. */
export interface EmbeddedBillProps extends HTMLAttributes<HTMLDivElement> {
  bookingId: string;
  bookingCode: string;
  isEditing: boolean;
  onOpenBooking: () => void;
  /** Akcja wiersza — modal edycji pozycji żyje na poziomie ekranu. */
  onRowAction: (row: BillRowVm) => void;
}

/**
 * Szkielety nie mają propsa `embedded`, którym widoki gubią ramkę w kaflu —
 * te same klasy trzeba im podać wprost.
 */
export const embeddedSkeletonClass = 'rounded-none border-0 shadow-none';
